import { MessageBarType } from '@fluentui/react';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { cloneDeep } from 'lodash';
import { RootState } from '../../../store';
import generateId from '../../../tools/generateId';
import { IAlertPayload, IState } from './interfaces';

const initialState: IState = {
    alerts: [],
};

const AlertsReducer = createSlice({
    name: 'AlertsReducer',
    initialState,
    reducers: {
        /**
         * Добавление нового алерта
         */
        storeNewAlert: (state, action: PayloadAction<IAlertPayload>) => {
            const { alerts } = cloneDeep(state);

            const newAlert = {
                ...action.payload,
                id: generateId(),
            };
            alerts.push(newAlert);

            state.alerts = alerts;
        },

        /**
         * Удаление алерта
         */
        removeAlert: (state, action: PayloadAction<string>) => {
            const { alerts } = cloneDeep(state);

            const filteredAlerts = alerts?.filter((element) => element.id !== action.payload);

            state.alerts = filteredAlerts;
        },
    },
});

export const { storeNewAlert, removeAlert } = AlertsReducer.actions;

export const AlertsReducerValues = (state: RootState) => state.AlertsReducer;

export default AlertsReducer.reducer;
